<div class="functie-assignment-dialog">
    <!-- Dialog Header -->
    <div class="dialog-header">
        <h2 mat-dialog-title class="w-100" style="width: 100% !important">
            Gestionare Asignări Funcții
            <span class="cerere-type-name">{{ data.cerereTypeName }}</span>
        </h2>
    </div>

    <!-- Loading State -->
    <div *ngIf="loading" class="loading-container">
        <mat-spinner diameter="40"></mat-spinner>
        <p>Se încarcă datele...</p>
    </div>

    <!-- Main Content -->
    <div mat-dialog-content class="dialog-content" *ngIf="!loading">

        <!-- Validation Errors -->
        <div *ngIf="validationErrors.length > 0" class="validation-errors">
            <mat-card class="error-card">
                <mat-card-content>
                    <div class="error-header">
                        <mat-icon color="warn">error</mat-icon>
                        <strong>Erori de validare:</strong>
                    </div>
                    <ul>
                        <li *ngFor="let error of validationErrors" class="error-item">
                            {{ error.message }}
                        </li>
                    </ul>
                </mat-card-content>
            </mat-card>
        </div>

        <!-- Instructions -->
        <div class="instructions">
            <mat-card class="info-card">
                <mat-card-content>
                    <div class="info-header">
                        <mat-icon color="primary">info</mat-icon>
                        <strong>Instrucțiuni:</strong>
                    </div>
                    <p>
                        Configurați asignările de funcții pentru acest tip de cerere.
                        Pentru fiecare asignare, selectați funcția și organizarea (Direcția și opțional Compartimentul).
                        Puteți specifica și un utilizator implicit. Utilizați drag-and-drop pentru a reordona
                        asignările.
                    </p>
                </mat-card-content>
            </mat-card>
        </div>

        <!-- Assignment Form -->
        <form [formGroup]="assignmentForm" class="assignment-form">
            <div formArrayName="assignments">

                <!-- Drag and Drop Container -->
                <div cdkDropList (cdkDropListDropped)="onDrop($event)" class="assignments-container">

                    <!-- Assignment Item -->
                    <div *ngFor="let assignment of assignmentsArray.controls; let i = index" [formGroupName]="i" cdkDrag
                        class="assignment-item" [class.assignment-item-dragging]="false">

                        <!-- Drag Handle -->
                        <div cdkDragHandle class="drag-handle">
                            <mat-icon>drag_handle</mat-icon>
                            <span class="assignment-number">{{ i + 1 }}</span>
                        </div>

                        <!-- Assignment Content -->
                        <div class="assignment-content">

                            <!-- Row 1: Functie and Directie -->
                            <div class="assignment-row">
                                <mat-form-field class="form-field functie-field" appearance="outline">
                                    <mat-label>Funcția</mat-label>
                                    <mat-select formControlName="functie_id" required
                                        (openedChange)="onFunctieSelectClosed(i)">
                                        <mat-form-field class="px-2 w-100 sticky-input">
                                            <input matInput [formControl]="functiiControls[i]"
                                                (keydown)="$event.stopPropagation()"
                                                (click)="$event.stopPropagation()" />
                                        </mat-form-field>

                                        <mat-option *ngIf="filteredFunctiiByIndex[i]?.length === 0" disabled>
                                            <span>No results found</span>
                                        </mat-option>

                                        <mat-option *ngFor="let functie of filteredFunctiiByIndex[i]"
                                            [value]="functie.id">
                                            {{ functie.name }}
                                            <span *ngIf="functie.acronym" class="acronym">({{ functie.acronym }})</span>
                                        </mat-option>
                                    </mat-select>
                                    <mat-error *ngIf="assignment.get('functie_id')?.hasError('required')">
                                        Funcția este obligatorie
                                    </mat-error>
                                </mat-form-field>

                                <mat-form-field class="form-field directie-field" appearance="outline">
                                    <mat-label>Direcția</mat-label>
                                    <mat-select formControlName="directie_id" required
                                        (openedChange)="onDirectieSelectClosed(i)">
                                        <mat-form-field class="px-2 w-100 sticky-input">
                                            <input matInput [formControl]="directiiControls[i]"
                                                (keydown)="$event.stopPropagation()"
                                                (click)="$event.stopPropagation()" />
                                        </mat-form-field>

                                        <mat-option *ngIf="filteredDirectiiByIndex[i]?.length === 0" disabled>
                                            <span>No results found</span>
                                        </mat-option>

                                        <mat-option *ngFor="let directie of filteredDirectiiByIndex[i]"
                                            [value]="directie.id_directie">
                                            {{ directie.name }}
                                        </mat-option>
                                    </mat-select>
                                    <mat-error *ngIf="assignment.get('directie_id')?.hasError('required')">
                                        Direcția este obligatorie
                                    </mat-error>
                                </mat-form-field>
                            </div>

                            <!-- Row 2: Compartiment and User -->
                            <div class="assignment-row">
                                <mat-form-field class="form-field compartiment-field" appearance="outline">
                                    <mat-label>Compartimentul (opțional)</mat-label>
                                    <mat-select formControlName="compartiment_id"
                                        (openedChange)="onCompartimentDropdownOpened($event, i)"
                                        (selectionChange)="onCompartimentSelectClosed(i)">
                                        <mat-form-field class="px-2 w-100 sticky-input">
                                            <input matInput [formControl]="compartimenteControls[i]"
                                                (keydown)="$event.stopPropagation()"
                                                (click)="$event.stopPropagation()" />
                                        </mat-form-field>

                                        <mat-option *ngIf="filteredCompartimenteByIndex[i]?.length === 0" disabled>
                                            <span>No results found</span>
                                        </mat-option>

                                        <mat-option [value]="-1">-- Fără compartiment --</mat-option>
                                        <mat-option *ngFor="let compartiment of filteredCompartimenteByIndex[i]"
                                            [value]="compartiment.id_compartiment">
                                            {{ compartiment.name }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>

                                <mat-form-field class="form-field user-field" appearance="outline">
                                    <mat-label>Utilizatorul implicit (opțional)</mat-label>
                                    <mat-select formControlName="user_id"
                                        (openedChange)="onUserDropdownOpened($event, i)"
                                        (selectionChange)="onUserSelectClosed(i)">
                                        <mat-form-field class="px-2 w-100 sticky-input">
                                            <input matInput [formControl]="usersControls[i]"
                                                (keydown)="$event.stopPropagation()"
                                                (click)="$event.stopPropagation()" />
                                        </mat-form-field>

                                        <mat-option *ngIf="filteredUsersByIndex[i]?.length === 0" disabled>
                                            <span>No results found</span>
                                        </mat-option>

                                        <mat-option [value]="-1">-- Fără utilizator implicit --</mat-option>
                                        <mat-option *ngFor="let user of filteredUsersByIndex[i]" [value]="user.id">
                                            {{ user.name || user.full_name }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                        </div>

                        <!-- Remove Button -->
                        <div class="assignment-actions">
                            <button mat-icon-button color="warn" type="button" (click)="removeAssignment(i)"
                                [disabled]="assignmentsArray.length <= 1" matTooltip="Șterge asignarea">
                                <mat-icon>delete</mat-icon>
                            </button>
                        </div>
                    </div>
                </div>

                <!-- Add New Assignment Button -->
                <div class="add-assignment-section">
                    <button mat-stroked-button color="primary" type="button" (click)="addNewAssignment()"
                        class="add-assignment-button">
                        <mat-icon>add</mat-icon>
                        Adaugă o nouă asignare
                    </button>
                </div>
            </div>
        </form>

        <!-- Assignment Statistics -->
        <div class="assignment-statistics" *ngIf="assignmentsArray.length > 0">
            <mat-card class="stats-card">
                <mat-card-content>
                    <div class="stats-header">
                        <mat-icon color="accent">assessment</mat-icon>
                        <strong>Statistici:</strong>
                    </div>
                    <div class="stats-content">
                        <span class="stat-item">
                            <strong>Total asignări:</strong> {{ assignmentsArray.length }}
                        </span>
                        <span class="stat-item">
                            <strong>Cu utilizatori impliciți:</strong>
                            {{ getAssignmentsWithUsers() }}
                        </span>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
    </div>

    <!-- Dialog Actions -->
    <div mat-dialog-actions class="dialog-actions">
        <button mat-button type="button" (click)="cancel()" [disabled]="saving">
            Anulează
        </button>

        <button mat-raised-button color="primary" type="button" (click)="saveAssignments()"
            [disabled]="saving || assignmentForm.invalid">
            <mat-icon *ngIf="saving">hourglass_empty</mat-icon>
            <mat-icon *ngIf="!saving">save</mat-icon>
            {{ saving ? 'Se salvează...' : 'Salvează' }}
        </button>
    </div>
</div>